import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { MarketingAnalyticsEvent, MarketingAnalyticsEventType } from './marketingAnalyticsEventTypes';

interface MarketingAnalyticsScreenshotEvent extends MarketingAnalyticsEvent {
    carousel_position: number;
}

export class MarketingAnalyticsScreenshotType extends MarketingAnalyticsEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_CAROUSEL_SHOWN_IMPRESSION;
    }

    getBody(event: any): MarketingAnalyticsScreenshotEvent {
        const baseEvent = this.baseEvent(event);
        return {
            carousel_position: event.image.positionIndex,
            ...baseEvent,
        };
    }
}
